import { Link, useNavigate } from "react-router-dom";
import { CalendarPlus } from "lucide-react";
import { fmtDateTime, MODE_FR, STATUS_FR } from "../../lib/api";
import { usePatients, useSessions } from "../../hooks/useData";
import { PageHeader, Panel } from "./CareLayout";

const STATUS_CLS = { planned: "bg-sky-100 text-sky-800", in_progress: "bg-amber-100 text-amber-800", completed: "bg-emerald-100 text-emerald-800", stopped: "bg-red-100 text-red-800" };

export default function Sessions() {
  const nav = useNavigate();
  const { data: sessions } = useSessions();
  const { data: patients } = usePatients();
  const name = (id) => patients?.find((p) => p.id === id)?.name;
  const demo = patients?.find((p) => p.is_demo) || patients?.[0];
  return (
    <div data-testid="care-sessions">
      <PageHeader title="Séances" sub="Planification et historique">
        {demo && <button data-testid="sessions-new-button" onClick={() => nav(`/care/patients/${demo.id}/session/new`)} className="flex h-11 items-center gap-2 rounded-xl bg-brand px-4 text-sm font-bold text-white"><CalendarPlus className="h-4 w-4" />Nouvelle séance ({demo.name})</button>}
      </PageHeader>
      <Panel testId="sessions-table">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm">
            <thead><tr className="text-left text-xs uppercase text-muted-foreground/80"><th className="pb-2">Date</th><th>Patient</th><th>Niveau</th><th>Mode</th><th>Durée prévue</th><th>Statut</th><th></th></tr></thead>
            <tbody>
              {sessions?.map((s) => (
                <tr key={s.id} className="border-t border-border/60" data-testid={`session-row-${s.id}`}>
                  <td className="py-3">{fmtDateTime(s.started_at || s.created_at)}</td><td>{name(s.patient_id)}</td><td>Le Village</td>
                  <td>{MODE_FR[s.config.mode]}</td><td>{s.config.duration_min} min</td>
                  <td><span className={`rounded-full px-2.5 py-1 text-xs font-bold ${STATUS_CLS[s.status]}`}>{STATUS_FR[s.status]}</span></td>
                  <td className="text-right">{["completed", "stopped"].includes(s.status) && <Link className="font-semibold text-primary-strong hover:underline" to={`/care/sessions/${s.id}/report`}>Rapport</Link>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
